const doc = [({"en":({"js":({"merfoto":({"order_deliveries":({"delivery_methods":({"digital_download":({"options":({"digital_download":"Digital Download"})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;